import React from 'react';

export const CheckCircle = () => (
    <>
        <circle cx='12' cy='12' r='9' />
        <path d='M9 12l2 2l4 -4' />
    </>
);